export const aciDoors = {
    iconName: 'doors',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M20.297 21.648H4.456A2.463 2.463 0 012 19.192V11.21l.614-8.105C2.737 2.491 3.228 2 3.842 2h9.456c.736 0 1.35.246 1.842.86l7.859 8.596.368.49-.122.124c0 .123.122.245.122.368.369 2.456.123 5.035-.86 7.245l-.245.737c-.245.737-1.105 1.228-1.965 1.228zM3.842 3.228l-.614 8.105v7.86c0 .736.491 1.227 1.228 1.227h15.841c.369 0 .614-.245.86-.491l.368-.737c.86-2.087 1.106-4.298.737-6.631 0-.123 0-.123-.123-.246l-.49-.49-7.369-8.229c-.245-.245-.614-.368-.982-.368H3.842z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M22.262 12.438H2.614c-.368 0-.614-.246-.614-.614s.246-.614.614-.614h19.648c.369 0 .614.246.614.614s-.245.614-.614.614zM7.526 14.894H5.07c-.369 0-.614-.246-.614-.614 0-.369.245-.614.614-.614h2.456c.368 0 .614.245.614.614 0 .368-.246.614-.614.614z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
